export function collectTypes(fields: any) {
  return objectToKeys(fields).reduce(
    (types, lang) => [...types, ...selectTypes(objectToKeys(fields[lang]))],
    [] as any,
  );
}

export function selectTypes(linkPropNames: string[]) {
  return linkPropNames.filter((prop) => !prop.includes(':'));
}

export function objectToKeys(object: any) {
  return Object.keys(object);
}

export function fieldsOfALanguage(fields: any) {
  return fields[objectToKeys(fields)[0] || 'en'];
}
